<template>
  <b-container class="mt-5">
    <b-row>
      <b-col sm="12" lg="8" offset-lg="2" class="mt-5">
        <h1>Soundslides Video</h1>
        <h1 class="lead">Private download link</h1>
        <div v-if="export_loaded" class="mt-4">
          <p>
            <strong>Filename:</strong>
            {{ export_doc.mlt_video_uploaded_filename }}
          </p>
          <p class="mt-4">
            <DownloadButtonVideo
              :item_key="
                export_doc.show_key +
                  '/m/' +
                  export_doc.mlt_video_uploaded_filename
              "
            />
          </p>
        </div>
        <div v-if="!export_loaded" class="mt-4">
          <p v-if="!error">
            <WorldIcon :delay="300" /> Loading file information.
          </p>
          <p v-else>
            <v-icon name="exclamation-triangle" class="mr-2" /> There was no
            available download at this address.
          </p>
        </div>
      </b-col>
    </b-row>
    <Footer />
  </b-container>
</template>

<script>
// @ is an alias to /src
import { db } from "@/fstore";
import DownloadButtonVideo from "@/components/show/DownloadButtonVideo";
import WorldIcon from "@/components/WorldIcon";

export default {
  name: "VideoFileDownload",

  components: {
    DownloadButtonVideo,
    WorldIcon
  },
  data() {
    return {
      export_doc: {},
      export_loaded: false,
      error: false
    };
  },
  computed: {
    export_id() {
      return this.$route.params.id;
    }
  },
  mounted() {
    var _v = this;
    var export_id = this.export_id;
    var docRef = db.collection("video_export_logs").doc(export_id);
    docRef
      .get()
      .then(function(doc) {
        if (doc.exists) {
          _v.export_doc = doc.data();
          _v.export_loaded = true;
          console.log("export_doc", _v.export_doc);
        } else {
          // doc.data() will be undefined in this case
          console.log("No such document!");
          _v.error = true;
        }
      })
      .catch(function(error) {
        console.log("Error getting document:", error);
        _v.error = true;
      });
  }
};
</script>
